import { AlgoliaAssetPanel } from './AlgoliaAssetPanel'

/**
 * Wrapper component for the Algolia-powered asset panel
 */
export const AssetPanelWrapper = () => {
  return <AlgoliaAssetPanel />
}
